import { createLazyComponent } from '@muse-web/router'

export const AsyncShareDialogContainer = createLazyComponent(
    () => import(/* webpackChunkName: 'dialog-share' */ './ShareDialogContainer'),
    'ShareDialogContainer',
)
